import React, { useEffect, useState } from "react";
import { Steps, Popover } from "antd";
import "antd/dist/antd.css";

const { Step } = Steps;

const generatePopoverInfo = (schedule) => {
  let popoverInfo = [
    { title: 'Pick up', content: () => `${schedule?.originPortName || schedule?.origin?.company_name}` },
    { title: 'Port of Origin', content: () => `${schedule?.originPortName || schedule?.origin?.company_name}` },
  ];

  // Check for Transshipments
  if (schedule?.transshipments && schedule.transshipments.length > 0) {
    popoverInfo.push({
      title: 'Transshipments',
      content: () => (
        <div>
          {schedule.transshipments?.slice(0, 2)?.map((element, index) => (
            <div key={index}>
              <div><b>{element?.port_of_transshipment_name || element?.port_of_transhipment?.company_name}</b></div>
              <div>ETA: {element?.eta?.substring(0, 10)}</div>
              <div>ETD: {element?.etd?.substring(0, 10)}</div>
            </div>
          ))}
        </div>
      ),
    });
  }
  const destinationId = schedule?.destinationPortId || schedule?.destination?.id
  const dischargeId = schedule?.dischargeId || schedule?.discharge?.id
  //Check if Port of Discharge is the same as Port of Destination
  if (dischargeId !== destinationId) {
    popoverInfo.push(
      { title: 'Port of Discharge', content: () => `${schedule?.dischargePortName || schedule?.discharge?.company_name}` },
      { title: 'Rail', content: () => `${schedule?.destinationPortName || schedule?.destination?.company_name}` }
    );
  } else {
    popoverInfo.push(
      { title: 'Port of Discharge', content: () => `${schedule?.destinationPortName || schedule?.destination?.company_name}` }
    );
  }

  popoverInfo.push(
    { title: 'Delivery', content: () => `${schedule?.destinationPortName || schedule?.destination?.company_name}` }
  );
  
  return popoverInfo;
};

const customDot = (dot, { status, index, schedule }) => {
  const popoverInfo = generatePopoverInfo(schedule);

  return (
    <Popover
      title={popoverInfo[index]?.title}
      content={
        <span>
          <p>{popoverInfo[index]?.content(schedule) || ''}</p>
        </span>
      }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-record-circle"
        viewBox="0 0 16 16"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
      </svg>
    </Popover>
  );
};



function getThreeDaysBefore(dateString) {
  // Parse the input date string
  const date = new Date(dateString);
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    throw new Error('Invalid date');
  }

  // Subtract three days
  date.setDate(date.getDate() - 3);
  return formatDate(date)
}

const generateSteps = (schedule) => {
  const stepsData = [];

  // Step 1: Origin to Discharge
  stepsData.push(
    { 
      // description: formatDate(schedule?.etd) || '', 
      description: (schedule?.etd?.substring(0,10)) || '', 
      companyName: (schedule?.originPortName || schedule?.origin?.company_name) },
  );

  // Step 2: Add transshipment steps if transshipment array is not empty
  if (Array.isArray(schedule?.transshipments) && schedule.transshipments.length > 0) {
    // If there's only one transshipment, show its company name
    if (schedule.transshipments.length === 1) {
      const transshipment = schedule.transshipments[0];
      stepsData.push({
        description: "",
        companyName: (transshipment?.port_of_transshipment_name || transshipment?.port_of_transhipment?.company_name),
      });
    } else {
      // If there are multiple transshipments, show the count
      stepsData.push({
        description: "",
        companyName: `${schedule.transshipments.length} T/S`,
      });
    }
  }
  const destinationId = schedule?.destinationPortId || schedule?.destination?.id
  const dischargeId = schedule?.dischargeId || schedule?.discharge?.id
  // Step 3: If discharge and destination are different, add discharge to destination step
  if (dischargeId!== destinationId) {
    stepsData.push({
      description:
      (((schedule?.etaPortOfDischarge?.substring(0,10) || schedule?.eta_port_of_discharge?.substring(0,10)) || '') ||
      ((schedule?.etdPortOfDischarge?.substring(0,10) || schedule?.etd_port_of_discharge?.substring(0,10)) || '')),
      companyName: (schedule?.dischargePortName || schedule?.discharge?.company_name),
    });
  }

  // Step 4: Destination (always there)
  stepsData.push({
    description: (schedule?.etaPortOfDestination?.substring(0,10) || schedule?.eta_destination)?.substring(0,10) || '',
    companyName: (schedule?.destinationPortName || schedule?.destination?.company_name),
  });


  return stepsData.map((step, index) => (
    <Step
      key={index}
      status="finish"
      title={<div className="custom-step-title">{step.companyName}</div>}
      description={step.description}
      disabled={index === 0 || index === stepsData.length - 1}
    />
  ));
};

const formatDate = (dateObject) => {
    if(dateObject){
        const date = new Date(dateObject);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const formattedDate = date.toLocaleString('en-US', options);
        return formattedDate
    }
  }

  export default  function ScheduleTimeline  ({ schedule })
  {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Adjust breakpoint if needed
      };

      handleResize(); // Initial check
      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return (
      <>
        <Steps
          progressDot={(dot, { status, index }) =>
            customDot(dot, { status, index, schedule })
          }
          direction={isMobile ? "vertical" : "horizontal"}
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            marginLeft: isMobile ? '1rem' : '-0.5rem'
          }}
        >
          <Step status="wait" disabled title={schedule?.originPortName || schedule?.origin?.company_name}//description={getThreeDaysBefore(schedule?.etd)}
          />
          {generateSteps(schedule)}
          <Step status="wait" disabled title={schedule?.destinationPortName || schedule?.destination?.company_name}
            description={(schedule?.etaPortOfDestination?.substring(0,10) || schedule?.eta_destination?.substring(0,10))}
          />
        </Steps>
      </>
    );
  };
